import React, { useState } from "react";
import "../Contact/contact2.css";

const Contact2 = () => {
  const [error, setError] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    
    const formData = new FormData(event.target);
    const name = formData.get("name").trim();
    const phone = formData.get("phone").trim();
    const email = formData.get("email").trim();
    const message = formData.get("message").trim();

    if (!name || !phone || !email || !message) {
      setError("All fields are required!");
      return;
    }

    setError(""); // Clear previous errors

    formData.append("access_key", "5b43cfff-da64-47c1-b7c4-f4e484bf62a2");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      event.target.reset();
    } else {
      console.log("Error", data);
    }
  };

  return (
    <div className="contact2-container">
      <div className="contact2-left">
        <h1>WE'RE HERE TO HELP!</h1>
        <p>
          PLEASE SEND US YOUR QUERY VIA THE FORM BELOW OR SEND US AN EMAIL AT
          <br />
          <strong>Ventures@duskytech.co</strong>
          <br />
          OR ANY ISSUE YOU'RE FACING
        </p>
        
        {/* Moved the form inside the left section */}
        <form onSubmit={onSubmit}>
          {error && <p className="error-message">{error}</p>} {/* Bigger Error Message */}
          
          <label htmlFor="name">NAME</label>
          <input type="text" id="name" name="name" />

          <label htmlFor="phone">PHONE NUMBER</label>
          <input type="tel" id="phone" name="phone" />

          <label htmlFor="email">EMAIL</label>
          <input type="email" id="email" name="email" />

          <label htmlFor="message">MESSAGE</label>
          <textarea id="message" name="message"></textarea>

          <button type="submit" className="contact2-submit">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact2;
